import {FC, useEffect} from "react";
import {useSelector, useDispatch} from "react-redux";

import CustomMultiSelect from "../../custom/customMultiSelect/customMultiSelect";

import {AppDispatch} from "../../../redux/reducer/store";
import {reducerSelectChartsType} from "../../../redux/reducer/charts/reducer/reducerCharts";
import {actionTest} from "../../../redux/action/charts/actionCharts";

import styles from "../headerBtn.module.scss";

const options = [
    {value: "visit", label: "Визиты (План/Факт)"},
    {value: "oss", label: "OSS"},
    {value: "mediumFace", label: "Средний фейсинг"},
    {value: "actions", label: "Акции: стартовала/не стартовала"},
    {value: "rateStatus", label: "Статусы оценки"},
    {value: "checkStatus", label: "Статусы проверки"},
    {value: "facing", label: "Фэйсинг"},
    {value: "dynamics", label: "Динамика % качества отчётов"},
    {value: "reportsChart", label: "Отчёты проверен/не проверен"},
    {value: "tanderSignal", label: "Сигналы (План/Факт)"},
];

const AddChartSection: FC<{ id: string | undefined }> = ({id}) => {
    const dispatch: any = useDispatch<AppDispatch>();

    const {desktopList, selectChartsType} = useSelector(
        (state: any) => state.charts?.chartsList
    );
    const {data} = useSelector((state: any) => state.user.user);

    const optionsList = data.isAdmin
                        ? options
                        : options.filter(
            (option: { value: string; label: string }) =>
                !(
                    data?.settings.reviewStatus === false &&
                    option.value === "checkStatus"
                )
        );

    const spanContent =
        selectChartsType.chartsList && selectChartsType.chartsList.length > 0
        ? optionsList.filter((option) =>
                                 selectChartsType.chartsList.includes(option.value)
        )
        : [];

    useEffect(() => {
        const index = id
                      ? desktopList.findIndex((el: any) => el.id.toString() === id)
                      : 0;
        const findItem = desktopList[index];
        if (findItem && findItem.list.length) {
            const newList = findItem.list.map((el: any) => el.type);
            dispatch(
                reducerSelectChartsType({chartsList: Array.from(new Set(newList))})
            );
        } else {
            dispatch(reducerSelectChartsType({chartsList: []}));
        }
        // eslint-disable-next-line
    }, []);

    return (
        <div className={styles.block__info}>
            <div className={styles.limit__block}>
                <span className={styles.span__elem_start}>Диаграмма:</span>
                <div className={styles.error__input_block}>
                    <div className="multiselect__filter_block multiselect__filter_block__modal">
                        <CustomMultiSelect
                            setLoading={() => {}}
                            options={optionsList}
                            inputValues={selectChartsType}
                            isShowPlaceholder={true}
                            pageName="mapTypes1"
                            placeholder=""
                            name="chartsList"
                            limit={1}
                            reducer={reducerSelectChartsType}
                            action={actionTest}
                            activeOptions={selectChartsType.chartsList}
                        />
                        <div className={styles.multiselectContent}>
                            {selectChartsType.chartsList &&
                             selectChartsType.chartsList.length > 0 && (
                                 <span className={styles.span__elem}>
                    {spanContent.length > 0 &&
                     spanContent
                         .map((item: { label: string }) => item.label)
                         .join(", ")}
                  </span>
                             )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddChartSection;
